import React from "react" ;
import { ReactNode } from "react" ;
import ObservableState from "../utils/ObservableState" ;
import * as ui from "../native" ;
import ObservableComponent from "./ObservableComponent" ;
import BaseUIProps , { copyBaseUIProps } from "../native/ui/BaseUIProps" ;
import CallStatus from "../classes/CallStatus" ;
import D3EDisposable from "../rocket/D3EDisposable" ;
import InteractionType from "../classes/InteractionType" ;
import MaterialIcons from "../icons/MaterialIcons" ;
import TextView from "./TextView" ;
import Interaction from "../models/Interaction" ;
import LeadUtils from "../classes/LeadUtils" ;
import IconView from "./IconView" ;
import MessageDispatch from "../rocket/MessageDispatch" ;
import Query from "../classes/Query" ;
import { UsageConstants } from "../rocket/D3ETemplate" ;
import { BuildContext } from "../classes/BuildContext" ;


  export  interface  ProfileWidgetProps extends  BaseUIProps {   key?: string ;
   interaction: Interaction ;
 }

   class  _ProfileWidgetState extends  ObservableComponent<ProfileWidgetProps> {   static defaultProps = { interaction:null } ;
   static contextType = BuildContext ;
   context: React.ContextType<typeof BuildContext> ;
  public interactionDisposable: D3EDisposable ;
 public constructor ( props : ProfileWidgetProps ) {
 super(props);

this.initState();
 }
  public get interaction (  ) : Interaction {
 return this.props.interaction ; 
 }
  public initState (  ) {
 super.initState();

this.interactionDisposable=MessageDispatch.get().syncObject(this.props.interaction,UsageConstants.SUBSCRIPTION_ONINTERACTIONCHANGE_PROFILEWIDGET_INTERACTION_SYNCHRONISE);

this.runFetchDataQueryForInteraction();

this.interactionDisposable=MessageDispatch.get().syncObject(this.props.interaction,UsageConstants.QUERY_GETINTERACTIONBYID_PROFILEWIDGET_INTERACTION_FETCHDATA);

this.initListeners();

this.enableBuild=true;
 }
  public initListeners (  ) : void {
 this.updateSyncProperty('interaction',this.props.interaction);

this.on([ 'interaction', 'interaction.callStatus', 'interaction.createdDate', 'interaction.isIncoming', 'interaction.type' ],this.rebuild);
 }
  public componentDidUpdate ( prevProps : ProfileWidgetProps ) : void {
 super.componentDidUpdate(prevProps);

if ( prevProps.interaction !== this.props.interaction ) {
 this.updateObservable('interaction',prevProps.interaction,this.props.interaction);

this.runFetchDataQueryForInteraction();

this.fire('interaction',this);
 }
 }
  public runFetchDataQueryForInteraction  =  (  ) : void  =>  {
 if ( this.interaction == null ) {
 return ; 
 }

Query.get().getInteractionById(UsageConstants.QUERY_GETINTERACTIONBYID_PROFILEWIDGET_INTERACTION_FETCHDATA,this.interaction.id);
 }
  public render (  ) : ReactNode {
 let cStyle=this.context.theme;

return ui.Row({ mainAxisAlignment:ui.MainAxisAlignment.spaceBetween, children:[ ui.Column({ children:[ ui.Row({ mainAxisAlignment:this.interaction.isIncoming ? ui.MainAxisAlignment.start : ui.MainAxisAlignment.end, children:[ TextView({ data:this.interaction.createdDate !== null ? LeadUtils.toGMTFromDateTime(this.interaction.createdDate,{ format:'EEE, MMM y HH:mm' }) : '', style:new ui.TextStyle({color:cStyle.c19,fontSize:9,fontWeight:cStyle.tTextViewHeadlineSixFontWeightOn}), className:'HeadlineSix x1b5e', key:'0' }), ((this.interaction.type === InteractionType.Voicemail) ? IconView({ icon:MaterialIcons.voicemail, color:!this.interaction.isIncoming ? cStyle.c1 : cStyle.c10, size:20, states:ui.joinStates({ 'data-c0':!this.interaction.isIncoming },{}), className:'xa51a' }) : [  ]), ((this.interaction.type === InteractionType.Voicemail) ? TextView({ data:'Voicemail', states:ui.joinStates({ 'data-c0':!this.interaction.isIncoming },{}), style:new ui.TextStyle({fontWeight:ui.FontWeight.w500,color:!this.interaction.isIncoming ? cStyle.c1 : cStyle.c10}), className:'xec0' }) : ((this.interaction.type === InteractionType.Call) ? TextView({ data:this.interaction.callStatus === CallStatus.Cancelled ? 'Missed Call' : this.interaction.callStatus.name, states:ui.joinStates({ 'data-c0':this.interaction.callStatus === CallStatus.Initiated, 'data-c1':this.interaction.callStatus === CallStatus.InProgress, 'data-c2':this.interaction.callStatus === CallStatus.Ringing, 'data-c3':this.interaction.callStatus === CallStatus.Answered, 'data-c4':this.interaction.callStatus === CallStatus.Completed, 'data-c5':this.interaction.callStatus === CallStatus.Failed, 'data-c6':this.interaction.callStatus === CallStatus.Busy, 'data-c7':this.interaction.callStatus === CallStatus.Unanswered, 'data-c8':this.interaction.callStatus === CallStatus.Unknown, 'data-c9':this.interaction.callStatus === CallStatus.Connecting, 'data-c10':this.interaction.callStatus === CallStatus.Cancelled, 'data-c11':this.interaction.callStatus === CallStatus.Rejected },{}), style:new ui.TextStyle({fontWeight:ui.FontWeight.w500,color:this.interaction.callStatus === CallStatus.Initiated ? cStyle.c10 : this.interaction.callStatus === CallStatus.InProgress ? cStyle.c10 : this.interaction.callStatus === CallStatus.Ringing ? cStyle.c10 : this.interaction.callStatus === CallStatus.Answered ? cStyle.c1 : this.interaction.callStatus === CallStatus.Completed ? cStyle.c1 : this.interaction.callStatus === CallStatus.Failed ? cStyle.c10 : this.interaction.callStatus === CallStatus.Busy ? cStyle.c10 : this.interaction.callStatus === CallStatus.Unanswered ? cStyle.c10 : this.interaction.callStatus === CallStatus.Unknown ? cStyle.c10 : this.interaction.callStatus === CallStatus.Connecting ? cStyle.c10 : this.interaction.callStatus === CallStatus.Cancelled ? cStyle.c10 : this.interaction.callStatus === CallStatus.Rejected ? cStyle.c10 : null}), className:'x8632' }) : [  ])) ], className:'x0d69 hc', key:'0' }) ], key:'0' }) ], className:ui.join('ProfileWidget ' , this.props.className ?? ''), ...copyBaseUIProps(this.props,) }) ; 
 }
  public dispose (  ) : void {
 this.interactionDisposable?.dispose();

super.dispose();
 }
 }
export default function ProfileWidget ( props : ProfileWidgetProps ) {
 return React.createElement(_ProfileWidgetState,{ ..._ProfileWidgetState.defaultProps, ...props }) ; 
 }
